import React from "react";
import classNames from "classnames/bind";
import ChevronUp from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronUp24PxOutlined";
import ChevronDown from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronDown24PxOutlined";
import styles from "./ScrollButton.module.scss";

const cx = classNames.bind(styles);

export interface ScrollButtonProps
  extends React.ComponentPropsWithoutRef<"button"> {
  isZoomModal?: boolean;
  direction?: "next" | "previous";
}

export const ScrollButton = ({
  isZoomModal = false,
  direction = "previous",
  ...props
}: ScrollButtonProps) => {
  return (
    <button
      data-testid={`standard:gallery:scroll:button:${direction}`}
      className={cx(styles.button, styles.scrollButton, styles[direction], {
        inZoomModal: isZoomModal,
      })}
      {...props}
    >
      {direction === "previous" ? <ChevronUp /> : <ChevronDown />}
    </button>
  );
};
